var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('b-container',[_c('div',{staticClass:"header__logo"},[_c('h1',[_c('img',{attrs:{"src":"https://static.ciclic.com.br/svg/ciclic-logo.svg","alt":"Logo Ciclic"}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }